var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScatterBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 41,
    fill: "none",
    viewBox: "0 0 60 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2B2B35",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M0 40.002h60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2B2B35",
    strokeWidth: 0.5,
    d: "M.25.001v40.001"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 13.439,
    r: 6,
    fill: "#003F7F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 33.439,
    r: 3,
    fill: "#003F7F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 8.939,
    r: 8.5,
    fill: "#0298A6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 25.439,
    r: 8,
    fill: "#0069D1"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 23.939,
    r: 5.5,
    fill: "#0069D1"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.439,
    r: 4,
    fill: "#0298A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScatterBubble);
export default __webpack_public_path__ + "static/media/scatter_bubble.08dfd93dee6c323f350fe450dd74344a.svg";
export { ForwardRef as ReactComponent };